import { useEffect } from "react";

let activeLocks = 0;
let lockedScrollY = 0;

type StoredStyles = {
  bodyOverflow: string;
  bodyPosition: string;
  bodyTop: string;
  bodyLeft: string;
  bodyRight: string;
  bodyWidth: string;
  bodyOverscrollBehavior: string;
  htmlOverflow: string;
  htmlOverscrollBehavior: string;
};

const storedStyles: StoredStyles = {
  bodyOverflow: "",
  bodyPosition: "",
  bodyTop: "",
  bodyLeft: "",
  bodyRight: "",
  bodyWidth: "",
  bodyOverscrollBehavior: "",
  htmlOverflow: "",
  htmlOverscrollBehavior: "",
};

function lockBodyScroll() {
  if (typeof document === "undefined" || typeof window === "undefined") return;
  const body = document.body;
  const html = document.documentElement;

  if (activeLocks === 0) {
    lockedScrollY = window.scrollY || window.pageYOffset || 0;
    storedStyles.bodyOverflow = body.style.overflow;
    storedStyles.bodyPosition = body.style.position;
    storedStyles.bodyTop = body.style.top;
    storedStyles.bodyLeft = body.style.left;
    storedStyles.bodyRight = body.style.right;
    storedStyles.bodyWidth = body.style.width;
    storedStyles.bodyOverscrollBehavior = body.style.overscrollBehavior;
    storedStyles.htmlOverflow = html.style.overflow;
    storedStyles.htmlOverscrollBehavior = html.style.overscrollBehavior;

    html.style.overflow = "hidden";
    html.style.overscrollBehavior = "none";
    body.style.overflow = "hidden";
    body.style.position = "fixed";
    body.style.top = `-${lockedScrollY}px`;
    body.style.left = "0";
    body.style.right = "0";
    body.style.width = "100%";
    body.style.overscrollBehavior = "none";
  }

  activeLocks += 1;
  body.setAttribute("data-modal-open", "true");
}

function unlockBodyScroll() {
  if (typeof document === "undefined" || typeof window === "undefined") return;
  if (activeLocks === 0) return;

  activeLocks -= 1;
  if (activeLocks > 0) return;

  const body = document.body;
  const html = document.documentElement;

  if (activeLocks > 0) {
    body.setAttribute("data-modal-open", "true");
    return;
  }

  html.style.overflow = storedStyles.htmlOverflow;
  html.style.overscrollBehavior = storedStyles.htmlOverscrollBehavior;
  body.style.overflow = storedStyles.bodyOverflow;
  body.style.position = storedStyles.bodyPosition;
  body.style.top = storedStyles.bodyTop;
  body.style.left = storedStyles.bodyLeft;
  body.style.right = storedStyles.bodyRight;
  body.style.width = storedStyles.bodyWidth;
  body.style.overscrollBehavior = storedStyles.bodyOverscrollBehavior;
  body.removeAttribute("data-modal-open");
  window.scrollTo(0, lockedScrollY);
}

export default function useBodyScrollLock(enabled: boolean) {
  useEffect(() => {
    if (!enabled) return;
    lockBodyScroll();
    return () => unlockBodyScroll();
  }, [enabled]);
}
